import SjPlyrAudioBox from './src/main.js'

export default SjPlyrAudioBox



// WEBPACK FOOTER //
// ./core/components/sj-plyr-audio-box/index.js